class ContentSwitcher {
    constructor(el) {
        this.nav = el.querySelectorAll('[data-content-switcher-nav]');
        this.items = el.querySelectorAll('[data-content-switcher-item]');
        this.initEvents();
    }

    initEvents() {
        Array.from(this.nav).forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                this.activeItem = el.dataset.contentSwitcherNav;
                this.setActiveItem();
            })
        });
    }

    setActiveItem() {
        /*Array.from(this.nav).forEach((el) => {
            if(el.dataset.contentSwitcherNav !== this.activeItem) {
                el.parentElement.classList.remove('active');
            } else {
                el.parentElement.classList.add('active');
            }
        });*/

        Array.from(this.items).forEach((el) => {
            if(el.dataset.contentSwitcherItem !== this.activeItem) {
                el.classList.remove('active');
            } else {
                el.classList.add('active');
            }
        });
    }
}

export default ContentSwitcher;
